export default "__VITE_ASSET__BSlYchC7__"